import Print from './print'

Print.install = function (Vue) {
    Vue.components(Print.name, Print)
}

export default Print